import React from 'react';

import moment from 'moment/moment';

import cls from './InventoryStatus.module.css';
import { useInventoryStatus } from './useInventoryStatus';

import type { EquipmentInventoryStatus } from '../../model';

interface InventoryStatusProps {
    freeDate?: string;
    status: EquipmentInventoryStatus;
}

export const InventoryStatus = ({ status, freeDate }: InventoryStatusProps) => {
    const { inventoryData, t } = useInventoryStatus();
    if (status !== 0) {
        return (
            <span className={cls.inventoryStatus} style={{ color: inventoryData[status].color }}>
                <span>{inventoryData[status].text}</span>
            </span>
        );
    }

    if (freeDate) {
        return (
            <span className={cls.inventoryStatus} style={{ color: inventoryData[status].color }}>
                <span className={cls.inventoryStatusText}>{t('InventoryStatus.text')}</span>
                <span>{moment(freeDate).format('DD.MM.YYYY')}</span>
            </span>
        );
    }

    return null;
};
